import { requestApi, requestJson } from "@/lib/request"
import { commonParams } from "@/config/common"

class ResourceManager {
    static getResourceList(params) {
        return requestApi('/sys/tenant/resource/group/list', 'get', {}, params, true)
    }
    static getResourceDetail(id) {
        const url = `/sys/tenant/resource/group/detail/${id}`
        return requestApi(url, 'get')
    }
    static getCatalogueList(id) {
        const url = `/sys/tenant/resource/detail/${id}`
        return requestApi(url, 'get')
    }
    static getDownloadFileLink(resourceGroupId, resourceId) {
        const url = `/sys/tenant/resource/download/${resourceGroupId}/${resourceId}`
        console.error(url)
        return requestApi(url, 'get')
    }
    static getResourceListJson() {
        return requestJson(`${ commonParams.PAAS_CONFIG }/auth/authGroup.json`)
    }
}

export { ResourceManager }


// WEBPACK FOOTER //
// ./src/models/resource-manager.js